import { render, staticRenderFns } from "./OrderIncomes.vue?vue&type=template&id=42c42d2e&"
import script from "./OrderIncomes.vue?vue&type=script&lang=js&"
export * from "./OrderIncomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports